"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import { setupCaseCardHoverAnimation } from "@/layouts/webparts/cases/case-card-hover-animation";
import { canAnimatePointer, loadGsapWithScrollTrigger, shouldReduceMotion } from "@/lib/gsap";
export function useCasesGalleryAnimation(animationKey) {
  const $ = _c(4);
  const gridRef = useRef(null);
  let t0;
  let t1;
  if ($[0] !== animationKey) {
    t0 = () => {
      if (shouldReduceMotion()) {
        return;
      }
      if (!animationKey) {
        return;
      }
      let cleanup;
      let cancelled = false;
      const setupAnimation = async function setupAnimation() {
        const {
          gsap
        } = await loadGsapWithScrollTrigger();
        if (cancelled) {
          return;
        }
        const grid = gridRef.current;
        if (!grid) {
          return;
        }
        const allCards = gsap.utils.toArray(grid.querySelectorAll(".case-card"));
        const cards = gsap.utils.toArray(grid.querySelectorAll(".case-card:not([data-animated-in='true'])"));
        const hoverCleanups = canAnimatePointer() && window.matchMedia("(min-width: 1280px)").matches ? allCards.map(card => setupCaseCardHoverAnimation(gsap, card)) : [];
        if (cards.length === 0) {
          cleanup = () => {
            for (const cleanupHover of hoverCleanups) {
              cleanupHover();
            }
          };
          return;
        }
        const hasAnimatedCards = grid.querySelector(".case-card[data-animated-in='true']");
        gsap.set(cards, {
          x: 180,
          y: 40,
          opacity: 0,
          scale: 0.92,
          rotateY: -18,
          filter: "blur(12px)",
          transformPerspective: 1200,
          transformOrigin: "center right"
        });
        const markAsAnimated = () => {
          for (const card_0 of cards) {
            card_0.dataset.animatedIn = "true";
          }
        };
        const baseAnimation = {
          x: 0,
          y: 0,
          opacity: 1,
          scale: 1,
          rotateY: 0,
          filter: "blur(0px)",
          duration: 1.15,
          stagger: {
            each: 0.09,
            from: "start" as const
          },
          ease: "power4.out",
          clearProps: "filter",
          onComplete: markAsAnimated
        };
        const tween = hasAnimatedCards ? gsap.to(cards, baseAnimation) : gsap.to(cards, {
          ...baseAnimation,
          scrollTrigger: {
            trigger: grid,
            start: "top 79%",
            once: true
          }
        });
        cleanup = () => {
          for (const cleanupHover_0 of hoverCleanups) {
            cleanupHover_0();
          }
          tween.scrollTrigger?.kill();
          tween.kill();
        };
      };
      setupAnimation();
      return () => {
        cancelled = true;
        cleanup?.();
      };
    };
    t1 = [animationKey];
    $[0] = animationKey;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      gridRef
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}